import vm from '@/cache/storeTools.js'

import plantApi from '@/components/api/virtualPowerPlant.js'

var basestate = {
    variableNames:{
        cdz:[],
         gf:[],
        cn:[],
        xxCdz:['充电桩12307626','充电桩12307905','充电桩12308142','充电桩10366223','充电桩10388424']
        //id:"0"
    },
    showData: {

    },
    showXXData: {

    },
    showDnData: {
        dnzdn:'0',
        drzdn:'0',
        dyzdn:'0',
        zgl:'0',
        wendu:'0',
        sanreqiwendu:0,
        gonglvyinsu:0,
        dianwangpinlv:0,
        dangtianfadianliang:0,
        dangnianfadianliang:0,
        leijifadianliang:0,
        bingwanggonglv:0,
        cdzZdn:0
    },
    showCnData: {
        daiji: '',
        fadian:'',
        fangdian:'',
        maidianliang:0,
        shengyurongliang:0,
        dianciwendu:0,
        dangtianfadianliang:0,
        dangtianmaidianliang:0,
        dccfdgl:0,//电池充放电功率
        zmdl:0,//总卖电量
        zndl:0//总买电量
    }
}

var store = new vm.Vuex.Store({
        state:copy(basestate),
        getters: {
            getCdzVariableNames(state,getter) {
                return state.variableNames.cdz
            },
            getCdzShowData(state,getter) {
                return state.showData
            },
            getXXCdzShowData(state,getter) {
                return state.showXXData
            },
            getCnShowData(state,getter) {
              return state.showCnData
            },
            getGFVariableNames(state,getter) {
                return state.variableNames.gf
            },
            getCNVariableNames(state,getter) {
                return state.variableNames.cn
            },
            getVariableNames(state,getter) {
                return state.variableNames
            },
            getDnShowData(state,getter) {
                return state.showDnData
            },
            getXXCdzVariableNames(state,getter) {
                return state.variableNames.xxCdz
            }

        },
        mutations: {
            setVariableNames(state,data) {
                //vm.Vue.set(state,'showCnData',{})
                // state.showCnData.shengyurongliang = 0
                state.variableNames.cdz = []
                state.variableNames.gf = []
                state.variableNames.cn = []
                if(isempty(data)) {
                    //removeTask('getRealTimeValue')
                    vm.Vue.set(state,'showData',{})
                    vm.Vue.set(state,'showXXData',{})
                    vm.Vue.set(state,'showCnData',{})
                    vm.Vue.set(state,'showDnData',{})
                    state.showCnData.shengyurongliang = 0
                }else {
                    data.forEach((item,index) => {
                        switch (item.typeCode) {
                            case 'CDZ':
                                state.variableNames.cdz.push(item.name);
                                break
                            case 'GFNBQ':
                                state.variableNames.gf.push(item.name)
                                break
                            case 'GFCN':
                                state.variableNames.cn.push(item.name)
                                break
                        }
                    })
                }
            },
            getRealTimeValue(state) {
                if (isempty(store.getters.getCdzVariableNames)) {
                    return
                }
                plantApi.getCdzInfo(store.getters.getCdzVariableNames.join(','),store.getters.getCNVariableNames.join(','),
                    //plantApi.getCdzInfo('2#电瓶车充电桩采集,3#电瓶车充电桩采集,1#电瓶车充电桩采集,4#电瓶车充电桩采集',store.getters.getCNVariableNames.join(','),
                    store.getters.getGFVariableNames.join(','),store.getters.getXXCdzVariableNames.join(','),res => {
                    state.showData = res.cdz;
                    state.showXXData = res.xxCdz;
                    state.showDnData.dnzdn = res.dnzdn;
                    state.showDnData.dyzdn = res.dyzdn;
                    state.showDnData.drzdn = res.drzdn;
                    state.showDnData.zgl = res.zgl;
                    state.showDnData.cdzZdn = res.ljzdn;
                    //state.showDnData.wendu = Number(res.gf.gf0[0].split(":")[0]);

                    res.gf.gf0.forEach((item,index) => {
                        let k = Number(item.split(":")[0]);
                        if(index == 0) {
                            state.showDnData.wendu = k;
                        }
                        if(index == 1) {
                            state.showDnData.sanreqiwendu = k;
                        }
                        if(index == 2) {
                            state.showDnData.gonglvyinsu = k;
                        }
                        if(index == 3) {
                            state.showDnData.dianwangpinlv = k;
                        }
                        if(index == 4) {
                            state.showDnData.dangtianfadianliang = k;
                        }
                        if(index == 5) {
                            state.showDnData.dangnianfadianliang = k;
                        }
                        if(index == 6) {
                            state.showDnData.leijifadianliang = k;
                        }
                        if(index == 7) {
                            state.showDnData.bingwanggonglv = k;
                        }
                        }),
                    res.cn.gfcn0.forEach((item,index) => {
                        let i = Number(item.split(":")[0]);
                        if(index == 0) {
                            state.showCnData.daiji = i;
                        }
                        if(index == 1) {
                            state.showCnData.fadian = i;
                        }
                        if(index == 2) {
                            state.showCnData.fangdian = i;
                        }
                        if(index == 3) {
                            state.showCnData.maidianliang = i;
                        }
                        if(index == 4) {
                            state.showCnData.shengyurongliang = i;
                        }
                        if(index == 5) {
                            state.showCnData.dianciwendu = i;
                        }
                        if(index == 6) {
                            state.showCnData.dangtianfadianliang = i;
                        }
                        if(index == 7) {
                            state.showCnData.dangtianmaidianliang = i;
                        }
                        if(index == 8) {
                            state.showCnData.dccfdgl = i;
                        }
                        if(index == 9) {
                            state.showCnData.zmdl = i;
                        }
                        if(index == 10) {
                            state.showCnData.zndl = i;
                        }
                    });
                })
            }
        }
});
//对外提供
export default store
